import { useEffect, useState, useCallback } from 'react';
import { Card, Row, Col, Form, Button, Badge, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { api } from '../api/client';

export default function StudentTeachers() {
  const [teachers, setTeachers] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [filters, setFilters] = useState({ subject: '', city: '', min_rating: '', max_fee: '', search: '' });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/student/subjects').then(setSubjects).catch(() => {});
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setErr('');
    try {
      const qs = new URLSearchParams();
      Object.entries(filters).forEach(([k, v]) => { if (v !== '') qs.set(k, v); });
      const r = await api.get('/student/teachers' + (qs.toString() ? '?' + qs : ''));
      setTeachers(r);
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  }, [filters]);
  useEffect(() => { load(); }, [load]);

  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });
  const clear = () => setFilters({ subject: '', city: '', min_rating: '', max_fee: '', search: '' });

  return (
    <>
      <h3 className="mb-3">Browse Teachers</h3>

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Row className="g-2">
            <Col md={3}><Form.Control placeholder="Search name or bio" value={filters.search} onChange={set('search')} /></Col>
            <Col md={2}>
              <Form.Select value={filters.subject} onChange={set('subject')}>
                <option value="">Any subject</option>
                {subjects.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
              </Form.Select>
            </Col>
            <Col md={2}><Form.Control placeholder="City" value={filters.city} onChange={set('city')} /></Col>
            <Col md={2}><Form.Control type="number" placeholder="Min rating" min={0} max={5} step="0.1" value={filters.min_rating} onChange={set('min_rating')} /></Col>
            <Col md={2}><Form.Control type="number" placeholder="Max fee ₹" min={0} value={filters.max_fee} onChange={set('max_fee')} /></Col>
            <Col md={1}><Button variant="outline-secondary" onClick={clear}>Clear</Button></Col>
          </Row>
        </Card.Body>
      </Card>

      {err && <Alert variant="danger">{err}</Alert>}
      {loading ? <div className="text-center py-4"><Spinner /></div> : (
        <Row>
          {teachers.length === 0 && <Col><Alert variant="info">No teachers match these filters.</Alert></Col>}
          {teachers.map((t) => (
            <Col md={6} lg={4} key={t.id} className="mb-3">
              <Card className="shadow-sm h-100">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <h5 className="mb-1">{t.name}</h5>
                    <Badge bg="info">{Number(t.avg_rating).toFixed(1)} ★</Badge>
                  </div>
                  <p className="text-muted small mb-2">{t.qualifications} · {t.experience_years} yrs · {t.city || 'Online'}</p>
                  <p className="mb-2" style={{ minHeight: 40 }}>{(t.bio || '').slice(0, 100)}{t.bio && t.bio.length > 100 ? '...' : ''}</p>
                  <div className="mb-2">
                    {(t.subjects || []).slice(0, 4).map((s) => <Badge bg="light" text="dark" className="me-1 mb-1" key={s}>{s}</Badge>)}
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="small">
                      <strong>₹{Number(t.monthly_fee).toFixed(0)}</strong>/month · <span className="text-muted">₹{Number(t.demo_fee).toFixed(0)} demo</span>
                    </div>
                    <Button as={Link} to={`/student/teachers/${t.id}`} size="sm">View</Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </>
  );
}
